module.exports = __webpack_public_path__ + "img/shield-blank.14ae04af.svg";